import { cn } from "../../classNames-BzrkDnOD.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
//#region src/components/ScrollArea/ScrollBar.tsx
const ScrollBar = ({ className, orientation = "vertical", ...props }) => /* @__PURE__ */ jsx(ScrollAreaPrimitive.ScrollAreaScrollbar, {
	orientation,
	className: cn("tw:flex tw:touch-none tw:select-none tw:transition-color", {
		"tw:h-full tw:w-2.5 tw:p-px": orientation === "vertical",
		"tw:h-2.5 tw:flex-col tw:p-px": orientation === "horizontal"
	}, className),
	...props,
	children: /* @__PURE__ */ jsx(ScrollAreaPrimitive.ScrollAreaThumb, { className: cn("tw:relative", "tw:flex-1", "tw:rounded-full", "tw:bg-border", "tw:hover:bg-muted-foreground") })
});
//#endregion
//#region src/components/ScrollArea/ScrollArea.tsx
const ScrollArea = ({ ref, className, children, viewPortClassName, orientation, scrollBarClassName, ...props }) => /* @__PURE__ */ jsxs(ScrollAreaPrimitive.Root, {
	"data-slot": "scroll-area",
	className: cn("tw:peer/scroll-area tw:relative tw:overflow-hidden tw:focus-visible:outline-hidden", className),
	...props,
	children: [
		/* @__PURE__ */ jsx(ScrollAreaPrimitive.Viewport, {
			ref,
			className: cn("tw:h-full tw:w-full tw:rounded-[inherit] tw:focus-visible:outline-hidden", viewPortClassName),
			children
		}),
		orientation ? /* @__PURE__ */ jsx(ScrollBar, {
			className: scrollBarClassName,
			orientation
		}) : /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(ScrollBar, {
			className: scrollBarClassName,
			orientation: "vertical"
		}), /* @__PURE__ */ jsx(ScrollBar, {
			className: scrollBarClassName,
			orientation: "horizontal"
		})] }),
		/* @__PURE__ */ jsx(ScrollAreaPrimitive.Corner, {})
	]
});
//#endregion
export { ScrollArea, ScrollBar };

//# sourceMappingURL=ScrollArea.js.map